import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import React from "react";
import { useLayoutEffect } from "react";
import Slider from "react-slick";
import "./About.css";
import star from "./assets/star.png";
import ContactUs from "./ContactUs";
import Footer from "./Footer";

const ROOT_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";

function QuickStartKit(props) {
  useLayoutEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  function redirectFromIframe(link) {
    window.parent.postMessage(
      {
        redirectUrl: link,
      },
      "*"
    );
  }

  return (
    <>
      <div>
        {window.innerWidth > 900 ? (
          <video
            className="w-full bg-contain object-cover"
            loop
            muted
            autoPlay
            playsInline
            preload="none"
            src="https://d1cadrokl7e9dp.cloudfront.net/home/qsk.mp4"
          ></video>
        ) : (
          <video
            className="w-full bg-contain object-cover"
            loop
            muted
            autoPlay
            playsInline
            preload="none"
            src="https://d1cadrokl7e9dp.cloudfront.net/home/qsk_m.mp4"
          ></video>
        )}
      </div>

      <div className="flex w-full bk6:flex-col learn-more-container">
        <div
          className={`w-2/3 bk6:w-full bk6:ml-0 bk6:mr-0 relative bg-[#E1E1E1] order-2`}
        >
          <div className="flex flex-col h-full px-4">
            <div className="content-container">
              <p
                className="mt-4 text-gray-500 mb-0"
                style={{ whiteSpace: "pre-line" }}
              >
                Introducing the EZ ICE Quick Start Kit — an affordable and easy
                way to bring real ice to your backyard this winter. Built on the
                same patented, tool-free technology trusted by over 10,000
                families across the U.S. and Canada, this compact kit delivers
                the critical components so you can start creating magical
                outdoor memories.
              </p>
              <br />
              <h1 className="text-2xl font-bold">Product Highlights</h1>
              <ul
                className=" text-gray-500 list-disc pl-5"
                style={{ whiteSpace: "pre-line" }}
              >
                <li>16’ wide x 32’ long</li>
                <li>No tools required – installs in under 60 minutes</li>
                <li>Works on any surface – grass, pavement, concrete, etc</li>
                <li>No ground stakes needed</li>
                <li>Handles up to 7” of slope</li>
                <li>Upgrade in the future to a Pro Home Arena System</li>
                <li>Real Ice: Just add water and let it freeze</li>
              </ul>
              <br />
              <h1 className="text-2xl font-bold">What’s Included</h1>
              <ul
                className=" text-gray-500 list-disc pl-5"
                style={{ whiteSpace: "pre-line" }}
              >
                <li>16 Brackets</li>
                <li>8 Straps (5 short, 3 long)</li>
                <li>2 EZ ICE Pucks</li>
                <li>20 Liner Clips</li>
                <li>4 Corner Liner Supports</li>
                <li>1 Rink Liner</li>
              </ul>
              <br />
              <p className=" text-gray-500" style={{ whiteSpace: "pre-line" }}>
                Not included: 12 wood boards (2"x12"x8'). Easily available from
                any lumber yard or big box hardware store.
              </p>
            </div>
          </div>
        </div>
        <div className="bk6:hidden flex flex-col justify-center items-center w-1/3 bk6:w-full relative order-1">
          <div className="px-16">
            <img
              className={`home-bg-video bk6m:mb-4 w-full bg-contain object-cover border-solid border-b-2 border-white`}
              src={"https://d1cadrokl7e9dp.cloudfront.net/home/qsk_logo.png"}
            />
          </div>
          <img
            className={`home-bg-video bk6m:mb-4 w-full bg-contain object-cover border-solid border-b-2 border-white`}
            src={"https://d1cadrokl7e9dp.cloudfront.net/home/qsk.png"}
          />
        </div>
      </div>

      <div className="flex flex-col items-center justify-center w-full bg-gray-100 py-8 gap-4">
        <a
          href="https://ezicerinks.com/pages/quick-start-kit-upgrade"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
          onClick={() =>
            redirectFromIframe(
              "https://ezicerinks.com/pages/quick-start-kit-upgrade"
            )
          }
        >
          Click here to Upgrade your Quick Start Kit
        </a>
        <a
          href="https://d1cadrokl7e9dp.cloudfront.net/home/Quick+Start+Kit+Assembly+Guide+091125a.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-ezice-blue-600 hover:bg-ezice-blue-800 text-white font-bold py-2 px-4 rounded"
        >
          Click here for Assembly Instructions
        </a>
      </div>

      <div className="flex flex-col justify-center w-full pt-8 px-4 md:px-8 lg:px-16">
        <div className="flex flex-col justify-center w-full mt-8">
          <h2 className="text-center font-bold bk3:text-2xl">
            The EZ ICE Quick Start Kit is available at the following select
            retailers:
          </h2>
        </div>
        <div className="flex flex-wrap justify-center w-full mt-4 max-w-6xl mx-auto">
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Colorado</h3>
            <a
              href="https://maps.app.goo.gl/UvKe3rvH7sXBzCSb6"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Littleton, CO
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/tqcsdd7yjXfA1sqx7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              The Stick Rack - Fort Collins, CO
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Illinois</h3>
            <a
              href="https://maps.app.goo.gl/xo9cnfqq5HxzewABA"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Downers Grove, IL
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Massachusetts</h3>
            <a
              href="https://maps.app.goo.gl/QotbtU2tU2oeaVEa7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Cooke’s Skate Supply - Wilmington, MA
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/Y6SveCSWf4BAmFEm6"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Burlington, MA
            </a>
            <br />
            <a
              href="https.app.goo.gl/AcuyeohBcQtma5y48"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Marlborough, MA
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/vCy3fzs69QQnE8g77"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Needham, MA
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/wq3X2T4KWMFQGBvm9"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Braintree, MA
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/78i2BDhxPsHfULrj7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Kingston, MA
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/xs3NmmVKX91qoG2a7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey - Danvers, MA
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Michigan</h3>
            <a
              href="https://maps.app.goo.gl/gs6z9cVSqC8rywn48"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Troy, MI
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Minnesota</h3>
            <a
              href="https://maps.app.goo.gl/8JcBXqoGyPWDp1jU8"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              General Sports, Edina, MN
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/RTT1vg96cVpLnYDX8"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Edina, MN
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/i9dJ4e8LJhkrz1We9"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Top Shelf Hockey Shop, Bemidji, MN
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">New Hampshire</h3>
            <a
              href="https://maps.app.goo.gl/ab6EF8TFxBtuZqML6"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              CSG Hockey, Concord, NH
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/qZR6hkjaHDnc1Hdd7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Nashua, NH
            </a>
            <br />
            <a
              href="https://maps.app.goo.gl/8RQo86N3HZ4mZjZn9"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Portsmouth, NH
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">New Jersey</h3>
            <a
              href="https://maps.app.goo.gl/zcDqzGfsyLVxreeQ7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Fairfield, NJ
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">New York</h3>
            <a
              href="https://maps.app.goo.gl/FQmvHAypCvxNiaP47"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Amherst, NY
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Pennsylvania</h3>
            <a
              href="https://maps.app.goo.gl/ogSyWT51BfWEoQkbA"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Cranberry Township, PA
            </a>
          </div>
          <div className="w-full p-4 md:w-1/3">
            <h3 className="text-xl font-bold">Wisconsin</h3>
            <a
              href="https://maps.app.goo.gl/1DvuuJTKeCU5KnuPA"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-800"
            >
              Pure Hockey, Monona, WI
            </a>
          </div>
        </div>
      </div>

      <div className="flex w-full justify-center my-4">
        <a
          href="https://ezicerinks.com/products/quick-start-kit-16x32-1?variant=41969380065383"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-500 hover:bg-red-700 text-white font-bold text-2xl py-2 px-24 rounded"
          onClick={() =>
            redirectFromIframe(
              "https://ezicerinks.com/products/quick-start-kit-16x32-1?variant=41969380065383"
            )
          }
        >
          Buy Online!
        </a>
      </div>

      <ContactUs />
      <Footer />
    </>
  );
}

export default QuickStartKit;
